<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <Breadcrumbs main="Chargers" title="default" />

  <div class="container-fluid p-0"
    >
    <div class="row widget-grid" >
      <div class="pl-4">
      <FilterS1
        :stateProp="stateList"
        :periodNameProp="`Current MP`"
        :showSessionFilters="true"
        :showRefreshButton="showSessionRefreshButton"
        :refreshing="refreshingSessionCache"
        :refreshDisabled="!isValidMpId(filter.mp_id) || countBreakloading"
        :updatedAt="sessionCacheUpdatedAt"
        @filterHandle="filterHandle"
        @refreshCache="refreshSessionChargerCache"
       />
      </div>
      <el-row :class="$vuetify.display.width < 750 ? 'm-0 width-100-p mt-0' : 'm-0 width-100-p m-t-8'">
        <!-- Hidden for session-scoped views: dashboard-chargers-data is too slow. Hidden from auditors on All chargers. -->
        <template v-if="showInventoryCharts">
        <!-- Charger by State -->
        <el-col
          :span="
            $vuetify.display.width >= 1500
              ? 8
              : $vuetify.display.width < 700
              ? 24
              : 12
          "
          :class="$vuetify.display.width < 700 ? 'width-100-p px-10 py-0 min-h-350' : 'width-100-p p-2 py-0 min-h-350'"
        >
          <div
            class="row m-0 p-2 bg-me-primary border-color-light rounded-4 min-h-350 height-100-p"
          >
            <el-col :span="24">
              <h5 class="text-white mt-3 ml-1">Charger by electricity region</h5>
            </el-col>
            <el-col
              :span="24"
              class="mt-2"
              v-loading="loadingChart"
              :element-loading-spinner="svg"
              element-loading-svg-view-box="-10, -10, 50, 50"
              element-loading-background="rgba(122, 122, 122, 0.8)"
            >
              <div
                id="chart"
                v-if="!loadingChart && chargerByState.length <= locationLimit"
              >
                <apexchart
                  type="donut"
                  :options="chargerPieOptions"
                  :series="chargerPieSeries"
                ></apexchart>
              </div>
              <div
                id="chart"
                v-else-if="
                  !loadingChart && chargerByState.length > locationLimit
                "
              >
                <apexchart
                  type="line"
                  :options="chargerLocationBarOptions"
                  :series="chargerLocationBarSeries"
                ></apexchart>
              </div>
            </el-col>
          </div>
        </el-col>
        <!-- Capacity Distribution -->
        <el-col
          :span="
            $vuetify.display.width >= 1500
              ? 8
              : $vuetify.display.width < 700
              ? 24
              : 12
          "
          :class="$vuetify.display.width < 700 ? 'width-100-p px-10 py-0 mt-20 min-h-350' :  'width-100-p p-2 py-0 min-h-350'"
        >
          <div
            class="row m-0 px-10 bg-me-primary border-color-light rounded-4 min-h-350 height-100-p"
          >
            <el-col :span="24">
              <h5 class="text-white mt-3 ml-1">Capacity Distribution</h5>
            </el-col>
            <el-col
              :span="24"
              class="mt-2"
              v-loading="loadingChart"
              :element-loading-spinner="svg"
              element-loading-svg-view-box="-10, -10, 50, 50"
              element-loading-background="rgba(122, 122, 122, 0.8)"
            >
              <div id="chart" v-if="!loadingChart">
                <apexchart
                  type="line"
                  :options="chargerCapacityOptions"
                  :series="chargerCapacitySeries"
                ></apexchart>
              </div>
            </el-col>
          </div>
        </el-col>
        <!-- Chargers Distribution -->
        <el-col
          :span="$vuetify.display.width >= 1500 ? 8 : 24"
          :class="$vuetify.display.width < 700 ? 'width-100-p py-0 px-10' : $vuetify.display.width < 1500 ? 'width-100-p p-0' :  'width-100-p p-2 py-0'"
        >
          <Cards :dataProp="chargingInfo" />
        </el-col>
        </template>
        <!-- Top performing charging sites -->

        <!-- charger count breakdown cards -->

        <el-col
          v-if="!isAuditor"
          :span="24"
          :class="$vuetify.display.width < 700 ? 'width-100-p py-0 px-10' : $vuetify.display.width < 1500 ? 'width-100-p p-0' :  'width-100-p p-2 py-0'"
        >
          <CountBreakdownCards
            :loading="countBreakloading"
            :dataProp="countBreakdownData"
          />
        </el-col>

        <!-- MP charger counts -->
        <el-col
          :span="24"
          :class="$vuetify.display.width < 700 ? 'width-100-p py-0 px-10' : $vuetify.display.width < 1500 ? 'width-100-p p-0' :  'width-100-p p-2 py-0'"
        >
          <MpChargerCountCards
            :loading="mpChargerCountsLoading"
            :dataProp="mpChargerCountsData"
            :errorMessage="mpChargerCountsError"
            :emptyMessage="mpChargerCountsEmptyReason"
          />
        </el-col>
      </el-row>





      <el-row class="m-0 width-100-p mt-3">
        <ChargerDistribution
          ref="chargerDistribution"
          :filterProp="filter"
          @updated-at="onDistributionUpdatedAt"
        />
        <PerformingSite :filterProp="filter" ref="performingDiv" />
      </el-row>
      <!-- DataTable -->
      <ChargerTable :filterProp="filter" :class="$vuetify.display.width >= 1400 ? 'my-30' : $vuetify.display.width >= 768 ? 'my-30' : $vuetify.display.width >= 375 ? 'my-24' : 'my-20'" />
    </div>

  </div>
</template>

<script>
// import Filter from "../common/filter.vue";
import { createLoadingInstance } from "../common/common-tools";
import FilterS1 from "@/pages/dashboard/common/filter-s1.vue";
import Cards from "./chargerCard";
import CountBreakdownCards from "./countBreakdownCards.vue";
import MpChargerCountCards from "./mpChargerCountCards.vue";
import ChargerTable from "./chargersTable.vue";
import ChargerDistribution from "./chargerDistribution.vue";
import PerformingSite from "./performingSite.vue";
import UserService from "../../../services/user.service";
import { chargerDonut, locationBarChart, capacityChart } from "./config.js";
export default {
  props: {},
  components: {
    // Filter,
    FilterS1,
    ChargerTable,
    ChargerDistribution,
    PerformingSite,
    Cards,
    CountBreakdownCards,
    MpChargerCountCards,
  },
  watch: {
    // "$vuetify.display.width"() {
    //   this.mapHeight = this.$refs.performingDiv.$el.clientHeight;
    //   console.log(this.$refs.performingDiv);
    // },
  },
  computed: {
    stateList() {
      return this.states;
    },
    isSessionFilterActive() {
      return Boolean(
        this.filter.with_sessions || this.filter.with_sessions_and_abatement
      );
    },
    isUnfilteredSessionCacheView() {
      const hasValue = (value) => value != null && String(value).trim() !== "";
      return (
        this.isSessionFilterActive &&
        this.isValidMpId(this.filter.mp_id) &&
        !hasValue(this.filter.customer_id) &&
        !hasValue(this.filter.elec_region) &&
        !hasValue(this.filter.country)
      );
    },
    isAdminUser() {
      return this.$store.state.auth.user != null && this.$store.state.auth.user.is_admin;
    },
    isAuditor() {
      return this.$store.state.auth.user != null && this.$store.state.auth.user.is_auditor;
    },
    showInventoryCharts() {
      return !this.isSessionFilterActive && !this.isAuditor;
    },
    showSessionRefreshButton() {
      return this.isAdminUser && this.isSessionFilterActive;
    },
    sessionCacheUpdatedAt() {
      if (!this.isUnfilteredSessionCacheView) {
        return "";
      }
      if (this.isAuditor) {
        return this.distributionUpdatedAt || "";
      }
      const countUpdatedAt = this.countBreakdownUpdatedAt;
      const distributionUpdatedAt = this.distributionUpdatedAt;
      const countTime = countUpdatedAt ? Date.parse(countUpdatedAt) : NaN;
      const distributionTime = distributionUpdatedAt ? Date.parse(distributionUpdatedAt) : NaN;
      if (!Number.isNaN(countTime) && !Number.isNaN(distributionTime)) {
        return countTime >= distributionTime ? countUpdatedAt : distributionUpdatedAt;
      }
      return countUpdatedAt || distributionUpdatedAt || "";
    },
  },
  data() {
    return {
      loadingChart: false,
      locationLimit: 7,
      countBreakloading: false,
      countBreakdownUpdatedAt: "",
      distributionUpdatedAt: "",
      refreshingSessionCache: false,


      chargerPieSeries: chargerDonut.series,
      chargerPieOptions: chargerDonut.chartOptions,

      chargerLocationBarSeries: locationBarChart.series,
      chargerLocationBarOptions: {
        ...locationBarChart.chartOptions,
        chargerLocationBarOriginalLabels: locationBarChart.originalLabels,
      },
      chargerLocationBarOriginalLabels: locationBarChart.originalLabels,

      chargerCapacitySeries: capacityChart.series,
      chargerCapacityOptions: capacityChart.chartOptions,

      // performingChargingSites: [],
      chargerDistribution: [],
      capacityDistribution: [],
      chargerByState: [],
      chargingInfo: {
        site_count: 0,
        charger_count: 0,
        port_count: 0,
        renewable_charger_count: 0,
      },
      countBreakdownData: {
        supported_charger_count: 0,
        operational_charger_count: 0,
        decommissioned_charger_count: 0,
      },
      mpChargerCountsLoading: false,
      mpChargerCountsError: "",
      mpChargerCountsEmptyReason: "",
      mpChargerCountsData: {
        mp_id: null,
        mp_name: null,
        mp_year: null,
        start_date: null,
        end_date: null,
        c1_year_added_before_mp: null,
        c1_decommissioned_before_mp: null,
        c1_active_until_before_mp: null,
        operational_start_of_mp: null,
        c2_year_added_eq_mp_year: null,
        c2_same_year_ops_after_mp_end: null,
        operational_added_in_mp: null,
        operational_chargers_in_mp: null,
        c3_decommissioned_in_mp: null,
        c3_active_until_in_mp: null,
        decommissioned_or_replaced_in_mp: null,
      },
      states: [],
      filter: {
        country: "",
        elec_region: "",
        startDate: null,
        endDate: null,
        customer_id: null,
        mp_id: null,
        with_sessions: false,
        with_sessions_and_abatement: false,
      },
      loading: false,
      // mapHeight: 400,

      statesList: [
        { title: "New South Wales", count: 771 },
        { title: "Australian Capital Territory", count: 300 },
        { title: "Sunshine Coast Region", count: 666 },
        { title: "Central Coast Council", count: 78 },
        { title: "Tasmania", count: 471 },
        { title: "Gold Coast-Tweed Heads", count: 2 },
        { title: "Shoalhaven City", count: 186 },
        { title: "Tasmania", count: 306 },
        { title: "Victoria", count: 393 },
        { title: "Port Phillip City", count: 258 },
        { title: "Gold Coast-Tweed Heads", count: 590 },
        { title: "Blue Mountains City", count: 480 },
        { title: "Darwin Municipality", count: 848 },
        { title: "Queensland", count: 575 },
        { title: "South Australia", count: 325 },
        { title: "Victoria", count: 347 },
        { title: "Tasmania", count: 160 },
        { title: "Blue Mountains City", count: 949 },
        { title: "Tasmania", count: 190 },
        { title: "Sunshine Coast Region", count: 195 },
        { title: "Central Coast Council", count: 42 },
        { title: "Western Australia", count: 982 },
        { title: "Cairns Regional Council", count: 439 },
        { title: "Tasmania", count: 104 },
        { title: "Mornington Peninsula Shire", count: 884 },
        { title: "Mackay Regional Council", count: 132 },
        { title: "South Australia", count: 815 },
        { title: "Toowoomba Regional Council", count: 305 },
        { title: "Shoalhaven City", count: 626 },
        { title: "Lake Macquarie City", count: 635 },
        { title: "Blue Mountains City", count: 342 },
        { title: "Central Coast Council", count: 754 },
        { title: "Mackay Regional Council", count: 571 },
        { title: "Toowoomba Regional Council", count: 192 },
        { title: "Victoria", count: 917 },
        { title: "Shoalhaven City", count: 224 },
        { title: "Toowoomba Regional Council", count: 856 },
        { title: "Gold Coast-Tweed Heads", count: 741 },
        { title: "Northern Territory", count: 676 },
        { title: "Toowoomba Regional Council", count: 658 },
        { title: "Mornington Peninsula Shire", count: 241 },
        { title: "Cairns Regional Council", count: 697 },
        { title: "Lake Macquarie City", count: 180 },
        { title: "New South Wales", count: 112 },
        { title: "Tasmania", count: 74 },
        { title: "Shoalhaven City", count: 986 },
        { title: "Gold Coast-Tweed Heads", count: 237 },
        { title: "South Australia", count: 942 },
        { title: "Sunshine Coast Region", count: 423 },
        { title: "Lake Macquarie City", count: 862 },
      ],
    };
  },
  async mounted() {
    // this.updateCurrentMonitoringPeriod();
    // await this.fetchData();
  },
  methods: {
    // updateCurrentMonitoringPeriod() {
    //   const currentMonitoringPeriod = sessionStorage.getItem("monitoringPeriods");
    //   let date = JSON.parse(currentMonitoringPeriod).filter((mp) => mp.status == "current" && mp.name == "Current MP");
    //       this.filter.startDate = date[0].start_date.replace("T", " ");
    //       this.filter.endDate = date[0].end_date.replace("T", " ");
    // },
    fillForm() {
      this.fillChargerByState();
    },
    fillChargerByState() {
      this.loadingChart = true;
      this.chargerPieSeries = [];
      this.chargerPieOptions.labels = [];
      // this.states = [];
      if (this.chargerByState.length <= this.locationLimit) {
        this.chargerByState.forEach((value) => {
          const locationLabel = value.elec_region || value.state || value.charging_site__elec_region || value.charging_site__state;
          this.chargerPieOptions.labels.push(locationLabel);
          this.chargerPieSeries.push(value.charger_count);
        });
      } else {
        this.chargerLocationBarSeries[0].data = [];
        this.chargerLocationBarOptions.labels = [];
        this.chargerLocationBarOriginalLabels = [];
        this.chargerByState.forEach((value) => {
          const locationLabel = value.elec_region || value.state || value.charging_site__elec_region || value.charging_site__state;
          this.chargerLocationBarOptions.labels.push(
            locationLabel
          );
          this.chargerLocationBarOriginalLabels.push(
            locationLabel
          );
          this.chargerLocationBarSeries[0].data.push(value.charger_count);
        });
        // Update the original labels in chart options for tooltip
        this.chargerLocationBarOptions.chargerLocationBarOriginalLabels = this.chargerLocationBarOriginalLabels;
        // this.statesList.forEach((value) => {
        //   this.chargerLocationBarOptions.labels.push(value.title);
        //   this.chargerLocationBarSeries[0].data.push(value.count);
        // });
      }
      this.chargerCapacitySeries[0].data = [];
      this.chargerCapacityOptions.labels = [];

      // set data ranges bins for capacity distribution
      const dataRanges = [
        { charger_count: 0, min:0, max:5, categoryName: "[0-5]" },
        { charger_count: 0, min:6, max: 10, categoryName: "[6-10]" },
        { charger_count: 0, min: 11, max: 15, categoryName: "[11-15]" },
        { charger_count: 0, min: 16, max: 20, categoryName: "[16-20]" },
        { charger_count: 0, min: 21, max: 25, categoryName: "[21-25]" },
        { charger_count: 0, min: 26, max: 30, categoryName: "[26-30]" },
        { charger_count: 0, min: 31, max: 45, categoryName: "[31-45]" },
        { charger_count: 0, min: 46, max: 60, categoryName: "[46-60]" },
        { charger_count: 0, min: 61, max: 75, categoryName: "[61-75]" },
        { charger_count: 0, min: 76, max: 100, categoryName: "[76-100]" },
        { charger_count: 0, min: 101, max: 125, categoryName: "[101-125]" },
        { charger_count: 0, min: 126, max: 150, categoryName: "[126-150]" },
        { charger_count: 0, min: 151, max: 175, categoryName: "[151-175]" },
        { charger_count: 0, min: 176, max: 200, categoryName: "[176-200]" },
        { charger_count: 0, min: 201, max: 300, categoryName: "[201-300]" },
        { charger_count: 0, min: 300, max: 99999999, categoryName: "300+" },
      ];
      this.capacityDistribution.forEach((value) => {
        dataRanges.forEach((range) => {
          if (value.charger_capacity_kW >= range.min && value.charger_capacity_kW <= range.max) {
            range.charger_count += value.charger_count;
          }
        });
        // this.chargerCapacitySeries[0].data.push(value.charger_count);
        // this.chargerCapacityOptions.labels.push(value.charger_capacity_kW);
      });

      // replace chart series and labels with ranged data and range labels
      dataRanges.forEach((range) => {
        this.chargerCapacitySeries[0].data.push(range.charger_count);
        this.chargerCapacityOptions.labels.push(range.categoryName);
      });

      setTimeout(() => {
        this.loadingChart = false;
      }, 300);
    },
    chargerSessionRequestFields() {
      return {
        mp_id: this.filter.mp_id,
        with_sessions: this.filter.with_sessions,
        with_sessions_and_abatement: this.filter.with_sessions_and_abatement,
      };
    },
    async fetchData() {
      let body = null;
      body = {
        customer_id: this.filter.customer_id,
        start_date: this.filter.startDate,
        end_date: this.filter.endDate,
        country: this.filter.country || "",
        elec_region: this.filter.elec_region || "",
        ...this.chargerSessionRequestFields(),
      };
      this.loading = true;
      await UserService.DashboardChargersData(body)
        .then(
          (response) => {
            this.chargerByState = response.data.data.charger_by_state;
            this.capacityDistribution =
              response.data.data.capacity_distribution;
            this.chargingInfo = response.data.data.charging_info;

            // Extract renewable_charger_count from the renewable_chargers object
            if (response.data.data.renewable_chargers && response.data.data.renewable_chargers.renewable_charger_count !== undefined) {
              this.chargingInfo.renewable_charger_count = response.data.data.renewable_chargers.renewable_charger_count;
            } else {
              this.chargingInfo.renewable_charger_count = 0;
            }

            this.renewableChargers = response.data.data.renewable_chargers;
            // this.chargerDistribution = response.data.data.charger_distribution;
            // this.performingChargingSites = response.data.data.performing_charging_sites;
            this.states = (response.data.data.states || []).map(
              (charger) => charger.elec_region || charger.state
            );
            this.fillForm();
          },
          (error) => {
            this.loading = false;
            console.log(error.message);
            // if (error.response.status == 401) {
            //   this.$router.push({
            //     path: "/",
            //   });
            // }
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error.message);
          // if (error.response.status == 401) {
          //   this.$router.push({
          //     path: "/",
          //   });
          // }
        })
        .finally(() => (this.loading = false));
    },

    async fetchChargerCountBreakdown(){
      try {
        this.countBreakloading = true;

        const response = await UserService.GetChargerCountBreakdown({
          customer_id: this.filter.customer_id,
          ...this.chargerSessionRequestFields(),
        });

        this.countBreakdownUpdatedAt =
          response && response.data && response.data.updated_at
            ? response.data.updated_at
            : "";

        if (response && response.data && response.data.count_total) {
          this.processCountBreakdownDataToCards(response.data.count_total);
        } else {
          console.warn('No count_total data received from API');
          this.countBreakdownData = {
            supported_charger_count: 0,
            operational_charger_count: 0,
            decommissioned_charger_count: 0
          };
        }
      } catch (error) {
        console.error('Error fetching charger count breakdown:', error.message);
        this.countBreakdownUpdatedAt = "";
        this.countBreakdownData = {
          supported_charger_count: 0,
          operational_charger_count: 0,
          decommissioned_charger_count: 0
        };
      } finally {
        this.countBreakloading = false;
      }
    },

    processCountBreakdownDataToCards(data) {

      if (!data) {
        this.countBreakdownData.supported_charger_count = 0;
        this.countBreakdownData.operational_charger_count = 0;
        this.countBreakdownData.decommissioned_charger_count = 0;
        console.log("no data for process");
        return;
      }

        Object.entries(data).forEach(([key, value]) => {
            if(key == "supported_charger_count"){
              this.countBreakdownData.supported_charger_count = value || 0;
            }
            if(key == "operational_charger_count"){
              this.countBreakdownData.operational_charger_count = value || 0;
            }
            if(key == "decommissioned_charger_count"){
              this.countBreakdownData.decommissioned_charger_count = value || 0;
            }
          });
    },

    emptyMpChargerCounts() {
      return {
        mp_id: null,
        mp_name: null,
        mp_year: null,
        start_date: null,
        end_date: null,
        c1_year_added_before_mp: null,
        c1_decommissioned_before_mp: null,
        c1_active_until_before_mp: null,
        operational_start_of_mp: null,
        c2_year_added_eq_mp_year: null,
        c2_same_year_ops_after_mp_end: null,
        operational_added_in_mp: null,
        operational_chargers_in_mp: null,
        c3_decommissioned_in_mp: null,
        c3_active_until_in_mp: null,
        decommissioned_or_replaced_in_mp: null,
      };
    },

    isValidMpId(mpId) {
      return mpId != null && mpId !== "" && Number.isFinite(Number(mpId));
    },

    async fetchMpChargerCounts() {
      this.mpChargerCountsError = "";
      this.mpChargerCountsEmptyReason = "";

      if (!this.isValidMpId(this.filter.mp_id)) {
        this.mpChargerCountsData = this.emptyMpChargerCounts();
        this.mpChargerCountsEmptyReason = "Select a monitoring period to view MP charger counts";
        return;
      }

      this.mpChargerCountsLoading = true;
      try {
        const request = {
          ...this.chargerSessionRequestFields(),
        };
        const isAdmin =
          this.$store.state.auth.user != null && this.$store.state.auth.user.is_admin;
        if (isAdmin && this.filter.customer_id != null && this.filter.customer_id !== "") {
          request.customer_id = this.filter.customer_id;
        }

        const response = await UserService.GetMpChargerCounts(request);
        const payload = response && response.data;
        const data = payload && payload.data;

        if (payload && Number(payload.code) === 1001) {
          this.mpChargerCountsData = this.emptyMpChargerCounts();
          this.mpChargerCountsError = payload.message || "Monitoring period not found";
          return;
        }

        if (data) {
          const counts = { ...this.emptyMpChargerCounts(), ...data };
          delete counts.operational_end_of_mp;
          this.mpChargerCountsData = counts;
          return;
        }

        this.mpChargerCountsData = this.emptyMpChargerCounts();
        this.mpChargerCountsEmptyReason = "No MP charger count data available";
      } catch (error) {
        console.error("Error fetching MP charger counts:", error);
        this.mpChargerCountsData = this.emptyMpChargerCounts();
        const apiMessage =
          error.response && error.response.data && error.response.data.message;
        this.mpChargerCountsError =
          apiMessage || error.message || "Failed to load MP charger counts";
      } finally {
        this.mpChargerCountsLoading = false;
      }
    },

    onDistributionUpdatedAt(updatedAt) {
      this.distributionUpdatedAt = updatedAt || "";
    },

    async refreshSessionChargerCache() {
      if (!this.isValidMpId(this.filter.mp_id)) {
        this.$message.warning("Select a monitoring period to refresh data.");
        return;
      }

      this.refreshingSessionCache = true;
      const refreshCountBreakdown = !this.isAuditor;
      if (refreshCountBreakdown) {
        this.countBreakloading = true;
      }
      try {
        const clearRequest = { mp_id: this.filter.mp_id };
        if (this.isAuditor) {
          clearRequest.endpoint = "charger-distributions";
        }
        await UserService.ClearSessionChargerCache(clearRequest);
        const distributionRefetch =
          this.$refs.chargerDistribution && this.$refs.chargerDistribution.fetchAllChargingSite
            ? this.$refs.chargerDistribution.fetchAllChargingSite()
            : Promise.resolve();
        const refetches = [distributionRefetch];
        if (refreshCountBreakdown) {
          refetches.push(this.fetchChargerCountBreakdown());
        }
        await Promise.all(refetches);
      } catch (error) {
        const apiMessage =
          error.response && error.response.data && error.response.data.message;
        this.$message.error(apiMessage || error.message || "Failed to refresh data.");
        if (refreshCountBreakdown) {
          this.countBreakloading = false;
        }
      } finally {
        this.refreshingSessionCache = false;
      }
    },

    async filterHandle(event) {
      const loading = createLoadingInstance();
      console.log("Charger filter : ", event);
      this.filter = event;
      if (this.showInventoryCharts) {
        await this.fetchData();
      }
      if (!this.isAuditor) {
        await this.fetchChargerCountBreakdown();
      }
      await this.fetchMpChargerCounts();
      loading.close();
    },
  },
};
</script>

<style></style>
